export default "__VITE_ASSET__DmZ5kHiX__"